(() => {
  const BrandBannerSwiper = new Swiper(".swiper.brands-banner__brands", {
    slidesPerView: 4,
    spaceBetween: 25,
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        500: {
            slidesPerView: 5,
          },
          900: {
            spaceBetween: 50,
        },
        1024: {
            slidesPerView: 5,
        }
    }
  });
})();
